var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinAuthor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0C8.05875 0 0 8.2826 0 18.5C0 28.7174 8.05875 37 18 37C27.9412 37 36 28.7174 36 18.5C36 8.2826 27.9412 0 18 0ZM13.5937 26.1679H9.94875V14.112H13.5937V26.1679ZM11.7487 12.632C10.5975 12.632 9.85312 11.7937 9.85312 10.757C9.85312 9.69901 10.62 8.88578 11.7956 8.88578C12.9712 8.88578 13.6912 9.69901 13.7137 10.757C13.7137 11.7937 12.9712 12.632 11.7487 12.632ZM26.9062 26.1679H23.2612V19.4867C23.2612 17.9315 22.7325 16.8755 21.4144 16.8755C20.4075 16.8755 19.8094 17.5904 19.545 18.2784C19.4475 18.5231 19.4231 18.87 19.4231 19.2149V26.1659H15.7762V17.9566C15.7762 16.4515 15.7294 15.1931 15.6806 14.1101H18.8475L19.0144 15.7847H19.0875C19.5675 14.9985 20.7431 13.8384 22.71 13.8384C25.1081 13.8384 26.9062 15.4899 26.9062 19.0396V26.1679Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinAuthor);
export default __webpack_public_path__ + "static/media/linkedinAuthor.9facafcc114e66a44ce66f8d927b75bf.svg";
export { ForwardRef as ReactComponent };